import { snakeCase } from "lodash";
import moment from "moment";

const prepareDataset = (type, patientObj, calStartDate, calEndDate) => {
  if (type !== undefined)
    switch (type) {
      // case "bleeds":
      //   return prepareDatasetForBleeds(
      //     type,
      //     patientObj,
      //     calStartDate,
      //     calEndDate
      //   );
      case "abnormalMotion":
        return prepareDatasetForAbnormalMotion(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "help":
        return prepareDatasetForHelp(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "visits":
        return prepareDatasetForVisits(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "allergy":
        return prepareDatasetForAllergies(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "weightlogs":
        return prepareDatasetForWeightLogs(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "heightlogs":
        return prepareDatasetForHeightLogs(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "hrmLogs":
        return prepareDatasetForHRMLogs(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      case "symptoms":
        return prepareDatasetForSymptoms(
          type,
          patientObj,
          calStartDate,
          calEndDate
        );
      default:
        return [];
    }
};

const prepareDatasetForBleeds = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  //console.log("patientObj...", patientObj);
  // console.log("st...", st.toString());
  // console.log("start...", st.startOf("day").toString());
  // console.log("end...", st.endOf("day").toString());
  // console.log("event timestamp...", moment(1677263400000).startOf("day").isSame(moment.unix(1677263400.0).startOf("day")));
  let bleedsReportedArr = [];
  let eventObj = patientObj[type];

  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    eventObj.forEach((events) => {
      let bleedEvent = events;
      if (
        st
          .startOf("day")
          .isSame(moment.unix(bleedEvent.eventTimestamp / 1000).startOf("day"))
      ) {
        if (bleedEvent !== undefined) {
          let bleedObj = bleedEvent;
          if (dateObj.timestamp) {
            let dataArr = dateObj.data;
            let eventData = {
              type: `${bleedObj.bleedSeverity} Bleed`,
              eventType: type,
              timestamp: bleedObj.eventTimestamp,
              date: bleedObj.eventTimestamp,
              notes: bleedObj.notes,
              //img: bleedObj.imageIDs,
              description:
                bleedObj.bleedAreaName !== undefined
                  ? snakeCase(bleedObj.bleedAreaName).replace(
                    new RegExp("_", "g"),
                    " "
                  )
                  : "",
            };
            dataArr.push(eventData);
            dateObj.data = dataArr;
          } else {
            dateObj.reported = true;
            dateObj.type = type;
            dateObj.timestamp = bleedObj.eventTimestamp;
            dateObj.data = [
              {
                type: `${bleedObj.bleedSeverity} Bleed`,
                eventType: type,
                timestamp: bleedObj.eventTimestamp,
                date: bleedObj.eventTimestamp,
                notes: bleedObj.notes,
                //img: bleedObj.imageIDs,
                description:
                  bleedObj.bleedAreaName !== undefined
                    ? snakeCase(bleedObj.bleedAreaName).replace(
                      new RegExp("_", "g"),
                      " "
                    )
                    : "",
              },
            ];
          }
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    bleedsReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return bleedsReportedArr;
};

const prepareDatasetForAbnormalMotion = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let abnormalMotionReportedArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["abnormalMotionEvents"];
    eventObj.forEach((events) => {
      let abnormalMotionEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment
              .unix(abnormalMotionEvent.eventTimestamp / 1000)
              .startOf("day")
          )
      ) {
        if (dateObj.timestamp) {
          let dataArr = dateObj.data;
          let eventData = {
            type: abnormalMotionEvent.isDayTimeEvent
              ? "Daytime Event Triggered"
              : "Nighttime Event Triggered",
            description:
              abnormalMotionEvent.eventClassifiedAs === null
                ? "Not Classified"
                : abnormalMotionEvent.eventClassifiedAs === "N"
                  ? "Not An Actual Event"
                  : abnormalMotionEvent.eventClassifiedAs === "T"
                    ? "Test Event"
                    : abnormalMotionEvent.eventClassifiedAs === "F"
                      ? "False Alarm"
                      : abnormalMotionEvent.eventClassifiedAs === "A" &&
                      "Actual Event",
            eventType: type,
            timestamp: abnormalMotionEvent.eventTimestamp,
            address: abnormalMotionEvent.address,
            duration: abnormalMotionEvent.totalEventDuration,
            minHr: abnormalMotionEvent.minHr,
            maxHr: abnormalMotionEvent.maxHr,
            avgHr: abnormalMotionEvent.avgHr,
          };
          dataArr.push(eventData);
          dateObj.data = dataArr;
        } else {
          dateObj.reported = true;
          dateObj.type = type;
          dateObj.timestamp = abnormalMotionEvent.eventTimestamp;
          dateObj.data = [
            {
              type: abnormalMotionEvent.isDayTimeEvent
                ? "Daytime Event Triggered"
                : "Nighttime Event Triggered",
              description:
                abnormalMotionEvent.eventClassifiedAs === null
                  ? "Not Classified"
                  : abnormalMotionEvent.eventClassifiedAs === "N"
                    ? "Not An Actual Event"
                    : abnormalMotionEvent.eventClassifiedAs === "T"
                      ? "Test Event"
                      : abnormalMotionEvent.eventClassifiedAs === "F"
                        ? "False Alarm"
                        : abnormalMotionEvent.eventClassifiedAs === "A" &&
                        "Actual Event",
              eventType: type,
              timestamp: abnormalMotionEvent.eventTimestamp,
              address: abnormalMotionEvent.address,
              duration: abnormalMotionEvent.totalEventDuration,
              minHr: abnormalMotionEvent.minHr,
              maxHr: abnormalMotionEvent.maxHr,
              avgHr: abnormalMotionEvent.avgHr,
            },
          ];
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    abnormalMotionReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return abnormalMotionReportedArr;
};

const prepareDatasetForHRMLogs = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let hrmLogsArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["heartRateMonitoringEvents"].filter((val) => { return val.eventSubType === "LTE" || val.eventSubType === "HTE" });
    eventObj.forEach((events) => {
      let hrmEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment
              .unix(hrmEvent.eventTimestamp / 1000)
              .startOf("day")
          )
      ) {
        if (dateObj.timestamp) {
          let dataArr = dateObj.data;
          let eventData = {
            type: hrmEvent.eventSubType === "LTE"
              ? "Low Heart Rate Threshold"
              : "High Heart Rate Threshold",
            description:
              "",
            eventType: type,
            timestamp: hrmEvent.eventTimestamp - (hrmEvent.totalEventDuration * 1000),
            address: hrmEvent.address,
            duration: hrmEvent.totalEventDuration,
            minHr: hrmEvent.minHeartRate,
            maxHr: hrmEvent.maxHeartRate,
            avgHr: hrmEvent.avgHeartRate,
          };
          dataArr.push(eventData);
          dateObj.data = dataArr;
        } else {
          dateObj.reported = true;
          dateObj.type = type;
          dateObj.timestamp = hrmEvent.eventTimestamp;
          dateObj.data = [
            {
              type: hrmEvent.eventSubType === "LTE"
                ? "Low Heart Rate Threshold"
                : "High Heart Rate Threshold",
              description:
                "",
              eventType: type,
              timestamp: hrmEvent.eventTimestamp - (hrmEvent.totalEventDuration * 1000),
              address: hrmEvent.address,
              duration: hrmEvent.totalEventDuration,
              minHr: hrmEvent.minHeartRate,
              maxHr: hrmEvent.maxHeartRate,
              avgHr: hrmEvent.avgHeartRate,
            },
          ];
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    hrmLogsArr.push(dateObj);
    st = st.add(1, "day");
  }
  return hrmLogsArr;
};

const prepareDatasetForHelp = (type, patientObj, calStartDate, calEndDate) => {
  let st = calStartDate.clone();
  let helpReportedArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["callAlerts"];
    eventObj.forEach((events) => {
      let helpEvent = events;
      if (
        st
          .startOf("day")
          .isSame(moment.unix(helpEvent.eventTimestamp / 1000).startOf("day"))
      ) {
        if (dateObj.timestamp) {
          let dataArr = dateObj.data;
          let eventData = {
            type: "Called For Help",
            eventType: type,
            timestamp: helpEvent.eventTimestamp,
            address: helpEvent.address,
          };
          dataArr.push(eventData);
          dateObj.data = dataArr;
        } else {
          dateObj.reported = true;
          dateObj.type = type;
          dateObj.timestamp = helpEvent.eventTimestamp;
          dateObj.data = [
            {
              type: "Called For Help",
              eventType: type,
              timestamp: helpEvent.eventTimestamp,
              address: helpEvent.address,
            },
          ];
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    helpReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return helpReportedArr;
};

const prepareDatasetForVisits = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let medicalVisitArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["medicalVisits"];

    eventObj.forEach((events) => {
      let umvEvent = events;

      if (
        st
          .startOf("day")
          .isSame(moment.unix(umvEvent.eventTimestamp / 1000).startOf("day"))
      ) {
        let isPlannedVisit = true;
        if (umvEvent.visitType.visitType !== undefined) {
          if (umvEvent.visitType.visitType === "Planned") {
            isPlannedVisit = true;
          } else {
            isPlannedVisit = false;
          }
        }
        if (dateObj.timestamp) {
          let dataArr = dateObj.data;
          let eventData = {
            type: isPlannedVisit
              ? "Medical Visit Planned"
              : "Medical Visit Unplanned",
            eventType: type,
            timestamp: umvEvent.eventTimestamp,
            umvDate: umvEvent.visitOrAdmissionDate,
            description: umvEvent.visitSubType.subType.toLowerCase(),
            isPlannedVisit,
            notes: umvEvent.notes,
            reason: umvEvent.visitReason.reason
              ? umvEvent.visitReason.reason
              : "",
            facilityName: umvEvent.facilityName ? umvEvent.facilityName : "-",
          };
          dataArr.push(eventData);
          dateObj.data = dataArr;
        } else {
          dateObj.reported = true;
          dateObj.type = type;
          //dateObj.timestamp = umvEvent.timestamp;
          dateObj.timestamp = umvEvent.eventTimestamp;
          dateObj.data = [
            {
              type: isPlannedVisit
                ? "Medical Visit Planned"
                : "Medical Visit Unplanned",
              eventType: type,
              timestamp: umvEvent.eventTimestamp,
              umvDate: umvEvent.visitOrAdmissionDate,
              description: umvEvent.visitSubType.subType.toLowerCase(),
              isPlannedVisit,
              notes: umvEvent.notes,
              reason: umvEvent.visitReason.reason
                ? umvEvent.visitReason.reason
                : "",
              facilityName: umvEvent.facilityName ? umvEvent.facilityName : "-",
            },
          ];
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    medicalVisitArr.push(dateObj);
    st = st.add(1, "day");
  }
  return medicalVisitArr;
};

const prepareDatasetForWeightLogs = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let weightLogReportedArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["weightLogList"];

    eventObj.forEach((events) => {
      let weightLogEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment.unix(weightLogEvent.eventTimestamp / 1000).startOf("day")
          )
      ) {
        if (weightLogEvent !== undefined) {
          let weightLogObj = weightLogEvent;
          if (dateObj.timestamp) {
            let dataArr = dateObj.data;
            let eventData = {
              type: "Weight Updated",
              eventType: type,
              timestamp: weightLogEvent.eventTimestamp,
              description: `${weightLogObj.weightLbs} lbs / ${weightLogObj.weightKg} kg`,
            };
            dataArr.push(eventData);
            dateObj.data = dataArr;
          } else {
            dateObj.reported = true;
            dateObj.type = type;
            dateObj.timestamp = weightLogEvent.eventTimestamp;
            dateObj.data = [
              {
                type: "Weight Updated",
                eventType: type,
                timestamp: weightLogEvent.eventTimestamp,
                description: `${weightLogObj.weightLbs} lbs / ${weightLogObj.weightKg} kg`,
              },
            ];
          }
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    weightLogReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return weightLogReportedArr;
};

const prepareDatasetForHeightLogs = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let heightLogReportedArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["heightLogList"];

    eventObj.forEach((events) => {
      let heightLogEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment.unix(heightLogEvent.eventTimestamp / 1000).startOf("day")
          )
      ) {
        if (heightLogEvent !== undefined) {
          let heightLogObj = heightLogEvent;
          if (dateObj.timestamp) {
            let dataArr = dateObj.data;
            let eventData = {
              type: "Height Updated",
              eventType: type,
              timestamp: heightLogObj.eventTimestamp,
              description: `${heightLogObj.heightFt} ft / ${heightLogObj.heightCm} cm`,
            };
            dataArr.push(eventData);
            dateObj.data = dataArr;
          } else {
            dateObj.reported = true;
            dateObj.type = type;
            dateObj.timestamp = heightLogObj.eventTimestamp;
            dateObj.data = [
              {
                type: "Height Updated",
                eventType: type,
                timestamp: heightLogObj.eventTimestamp,
                description: `${heightLogObj.heightFt} ft / ${heightLogObj.heightCm} cm`,
              },
            ];
          }
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    heightLogReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return heightLogReportedArr;
};

const prepareDatasetForAllergies = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let allergyReportedArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj["allergies"];

    eventObj.forEach((events) => {
      let allergyEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment.unix(allergyEvent.eventTimestamp / 1000).startOf("day")
          )
      ) {
        if (allergyEvent !== undefined) {
          let allergyObj = allergyEvent;
          if (dateObj.timestamp) {
            let dataArr = dateObj.data;
            let eventData = {
              type: "Allergy Reported",
              eventType: type,
              timestamp: allergyObj.eventTimestamp,
              description: allergyObj.allergySource.source.toLowerCase(),
              medicationName: allergyObj.medicationName,
              severity: allergyObj.severityText,
              notes: allergyObj.notes,
              reactions: allergyObj.reactions,
            };
            dataArr.push(eventData);
            dateObj.data = dataArr;
          } else {
            dateObj.reported = true;
            dateObj.type = type;
            dateObj.timestamp = allergyObj.eventTimestamp;
            dateObj.data = [
              {
                type: "Allergy Reported",
                eventType: type,
                timestamp: allergyObj.eventTimestamp,
                description: allergyObj.allergySource.source.toLowerCase(),
                medicationName: allergyObj.medicationName,
                severity: allergyObj.severityText,
                notes: allergyObj.notes,
                reactions: allergyObj.reactions,
              },
            ];
          }
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    allergyReportedArr.push(dateObj);
    st = st.add(1, "day");
  }
  return allergyReportedArr;
};


const prepareDatasetForSymptoms = (
  type,
  patientObj,
  calStartDate,
  calEndDate
) => {
  let st = calStartDate.clone();
  let symptomsArr = [];
  while (st.isSameOrBefore(calEndDate)) {
    let dateObj = {};
    let eventObj = patientObj;
    eventObj.forEach((events) => {
      let symptomsEvent = events;
      if (
        st
          .startOf("day")
          .isSame(
            moment
              .unix(symptomsEvent.eventTimestamp / 1000)
              .startOf("day")
          )
      ) {
        if (dateObj.timestamp) {
          let dataArr = dateObj.data;
          let eventData = {
            type: "Symptoms Reported",
            description:
              symptomsEvent.symptom.name,
            eventType: type,
            timestamp: symptomsEvent.eventTimestamp,
            duration: symptomsEvent.duration !== null ? `${symptomsEvent.duration} ${symptomsEvent.durationType}` : null,
            severity: symptomsEvent.severity.severity,
            otherSymptom: symptomsEvent.otherSymptom,
            symptomDescription: symptomsEvent.symptomDescription,
          };
          dataArr.push(eventData);
          dateObj.data = dataArr;
        } else {
          dateObj.reported = true;
          dateObj.type = type;
          dateObj.timestamp = symptomsEvent.eventTimestamp;
          dateObj.data = [
            {
              type: "Symptoms Reported",
              description:
                symptomsEvent.symptom.name,
              eventType: type,
              timestamp: symptomsEvent.eventTimestamp,
              duration: symptomsEvent.duration !== null ? `${symptomsEvent.duration} ${symptomsEvent.durationType}` : null,
              severity: symptomsEvent.severity.severity,
              otherSymptom: symptomsEvent.otherSymptom,
              symptomDescription: symptomsEvent.symptomDescription,
            },
          ];
        }
      }
    });
    if (Object.keys(dateObj).length === 0) {
      dateObj.reported = false;
      dateObj.timestamp = st.startOf("day");
    }
    symptomsArr.push(dateObj);
    st = st.add(1, "day");
  }
  return symptomsArr;
};

export default prepareDataset;
